import Text from '~/common/components/Texts/Text';
import theme from '~/theme/';

import { ElementConditions, ElementPlaceholder } from '../types/common';
import ConditionEvaluator from './utilityComponents/ConditionEvaluator';
import ContentWrapper from './utilityComponents/ContentWrapper';
import ProcessedText from './utilityComponents/ProcessedText';

type LedgerRowDef = {
  label: string;
  text?: string;
  placeholders?: ElementPlaceholder[];
  hasBottomBorder?: boolean;
  [key: string]: any;
};

type LedgerProps = {
  name?: string;
  rows?: LedgerRowDef[];
  conditions?: ElementConditions;
  hasBottomBorder?: boolean;
  padding?: string | number;
  metadata?: { index: number };
};

export default function Ledger({
  name = 'ledger',
  rows = [],
  conditions,
  hasBottomBorder = false,
  padding = '0',
  metadata,
}: Readonly<LedgerProps>) {
  return (
    <ConditionEvaluator conditions={conditions}>
      <ContentWrapper hasBottomBorder={hasBottomBorder} padding={padding}>
        {rows.map((row, index) => (
          <LedgerRow
            key={`${name}-row-${row.label}-${row.text}`}
            name={`${name}-row-${index}`}
            metadata={metadata}
            {...row}
          />
        ))}
      </ContentWrapper>
    </ConditionEvaluator>
  );
}

type LedgerRowProps = LedgerRowDef & {
  name?: string;
  metadata?: { index: number };
};

function LedgerRow({
  label,
  text,
  placeholders,
  hasBottomBorder = true,
  name,
  metadata,
  ...rest
}: Readonly<LedgerRowProps>) {
  const border = hasBottomBorder
    ? `1px solid ${theme.colors?.gray[200]}`
    : 'none';

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0.25rem 0.25rem',
        borderBottom: border,
      }}
    >
      <Text as="span" fontWeight="600">
        {label}
      </Text>
      <Text as="span" {...rest}>
        <ProcessedText
          text={text}
          placeholders={placeholders}
          metadata={metadata}
          name={name}
        />
      </Text>
    </div>
  );
}
